import React, { useEffect, useState } from 'react';
import './Drawer.css';
import { Row } from 'reactstrap';
import { ColTemplate } from 'views/Monitoring/Extension/components/TransferModal/style';
import userAgentSingleton from 'components/Navbars/ServicePanel/softphone/userAgent/userAgentSingleton';
import { toast } from 'react-toastify';
import DialpadKeypad from '../dialpadKeyboard';

const ContactDrawer = ({ isOpen, type, contactData, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({ id: null, nome: '', numero: '' });

  useEffect(() => {
    if (isOpen) {
      if (type === 'edit' || type === 'delete') {
        setFormData({
          id: contactData?.id ?? null,
          nome: contactData?.nome ?? '',
          numero: contactData?.numero ?? ''
        });
      } else if (type === 'add') {
        setFormData({ id: null, nome: '', numero: '' });
      } else if (type === 'transfer') {
        setFormData({
          id: null,
          nome: contactData?.nome ?? '',
          numero: contactData?.numero ?? ''
        });
      }
    }
  }, [isOpen, contactData, type]);

  const handleSubmit = () => {
    onSubmit(formData);
  };

  const isTransferValid = formData.numero && formData.numero.length > 0;

  const handleTransferAction = (transferType) => {
    if (!isTransferValid) {
      toast.warning('Digite um número para transferir.');
      return;
    }
    onClose();
    if (transferType === 'attended') {
      userAgentSingleton.attendedTransfer(formData.numero);
    } else {
      userAgentSingleton.blindedTransfer(formData.numero);
    }
  };

  return (
    <div className={`drawer-overlay ${isOpen ? 'open' : ''}`}>
      <div
        className="drawer"
        style={type === 'transfer' ? { maxWidth: '400px' } : {}}
      >
        <div className="drawer-header">
          <h3>
            {type === 'add'
              ? 'Adicionar Contato'
              : type === 'edit'
              ? 'Editar Contato'
              : type === 'delete'
              ? 'Deletar Contato'
              : 'Transferir Chamada'}
          </h3>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="drawer-body">
          {type === 'add' || type === 'edit' ? (
            <>
              <label>Nome</label>
              <input
                type="text"
                value={formData.nome}
                onChange={(e) =>
                  setFormData({ ...formData, nome: e.target.value })
                }
              />
              <label>Número</label>
              <input
                type="text"
                value={formData.numero}
                onChange={(e) =>
                  setFormData({ ...formData, numero: e.target.value })
                }
              />
            </>
          ) : type === 'delete' ? (
            <>
              <p className="delete-confirm-text">
                Tem certeza que deseja deletar este contato?
              </p>
              <div className="delete-contact-info">
                <p className="contact-name">{formData.nome}</p>
                <p className="contact-number">{formData.numero}</p>
              </div>
            </>
          ) : type === 'transfer' ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <DialpadKeypad
                value={formData.numero}
                onChange={(newVal) =>
                  setFormData({ ...formData, numero: newVal })
                }
                onEnter={() => handleTransferAction('blind')}
              />

              <Row style={{ width: '100%', marginTop: '20px' }}>
                <ColTemplate
                  sm="12"
                  onClick={() => handleTransferAction('attended')}
                  style={{
                    cursor: isTransferValid ? 'pointer' : 'not-allowed',
                    opacity: isTransferValid ? 1 : 0.6
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%'
                    }}
                  >
                    <h4>Transferência Assistida</h4>
                  </div>
                </ColTemplate>

                <ColTemplate
                  sm="12"
                  onClick={() => handleTransferAction('blind')}
                  style={{
                    cursor: isTransferValid ? 'pointer' : 'not-allowed',
                    opacity: isTransferValid ? 1 : 0.6
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%'
                    }}
                  >
                    <h4>Transferência Cega</h4>
                  </div>
                </ColTemplate>
              </Row>
            </div>
          ) : null}
        </div>

        {type !== 'transfer' && (
          <div className="drawer-footer">
            <button className="cancel-button" onClick={onClose}>
              Cancelar
            </button>
            <button
              className={type === 'delete' ? 'delete-button' : 'save-button'}
              onClick={handleSubmit}
            >
              {type === 'delete' ? 'Deletar' : 'Salvar'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactDrawer;
